import { useEffect } from 'react';

import { ReactComponent as TrustPilotIcon } from '../../../assets/trustpilot-logo.svg';
import { FooterIconHolder, FooterWidgetHolder } from '../footer.styles';

const TrustpilotMini = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src =
      'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.async = true;
    document.body.appendChild(script);

    if ((window as any).Trustpilot) {
      (window as any).Trustpilot.loadFromElement(
        document.querySelector('.trustpilot-widget'),
        true
      );
    }
  }, []);

  return (
    <FooterWidgetHolder>
      <FooterIconHolder>
        <TrustPilotIcon />
        <h6>Trustpilot</h6>
      </FooterIconHolder>

      <div
        className='trustpilot-widget'
        data-locale='en-US'
        data-template-id='5419b6ffb0d04a076446a9af'
        data-businessunit-id='679a4a6a4cb6342428507547'
        data-style-height='20px'
        data-style-width='100%'
        data-token='0caac89a-df34-45f8-9694-f8f281b4b829'>
        <a
          href='https://www.trustpilot.com/review/us.meest.com'
          target='_blank'
          rel='noopener'>
          Trustpilot
        </a>
      </div>
    </FooterWidgetHolder>
  );
};

export default TrustpilotMini;
